import { useCallback, useEffect, useMemo, useState } from 'react';
import { useQueryListHubs } from '../hubs.queries';

/** Hub filter options, loaded when the filter opens or straight away if a hub is already selected. */
export function useHubFilter(projectID: string, selectedHubID: string | null | undefined, onClear: () => void) {
  const [hubsRequested, setHubsRequested] = useState(false);
  const hubs = useQueryListHubs(projectID, { includeChildProjects: true, enabled: hubsRequested || !!selectedHubID });
  const onOpen = useCallback(() => setHubsRequested(true), []);

  const options = useMemo(() => (hubs.data || []).map((h) => ({ label: h.name, value: h.id })), [hubs.data]);

  // Clear a selection that isn't one of this project's hubs.
  useEffect(() => {
    if (hubs.isSuccess && selectedHubID && !options.find((o) => o.value === selectedHubID)) {
      onClear();
    }
  }, [hubs.isSuccess, selectedHubID, options, onClear]);

  return { options, loading: hubs.isLoading, onOpen };
}
